import { LightLoginProps } from '@msc-b2c/interfaces/types';
import { LightLogin } from './LightLogin';

export function LightLoginWrapper(lightLoginProps: Readonly<LightLoginProps>) {
  return <LightLogin {...lightLoginProps} />;
}

LightLoginWrapper.aemResourceType = 'b2c-website-foundation/components/mymsc/form/light-login';

export default LightLoginWrapper;
